export enum Constants {
    ADD_SENDER_LOGO = 'ADD_SENDER_LOGO',
    ADD_SENDERINFO_LIST = 'ADD_SENDERINFO_LIST',
    ADD_SELECTED_SENDER = 'ADD_SELECTED_SENDER',
    ADD_SENDER_ORGANIZATION_LIST = 'ADD_SENDER_ORGANIZATION_LIST',
}
